import {
  Component,
  ElementRef,
  ViewChild,
  forwardRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-color-palette',
  templateUrl: './color-palette.component.html',
  styleUrls: ['./color-palette.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPaletteComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ColorPaletteComponent implements ControlValueAccessor {
  @ViewChild('colorTextarea') colorTextarea: ElementRef;
  textareaValue: string;
  textareaFocused: boolean = false;
  colors: string[] = []; // this will be set by the form control value
  wrongColors: number[] = [];
  currentStep = 0;
  onChange: any = () => {};
  onTouched: any = () => {};

  ngOnInit() {
    this.textareaValue = this.colors.join('\n');
  }

  textareaFocus() {
    this.textareaFocused = true;
    this.colorTextarea.nativeElement.focus();
    this.textareaValue = this.colors.join('\n');
  }

  textareaBlur() {
    this.textareaFocused = false;
    this.extractHexCodes(true);
    this.onChange(this.colors);
    this.onTouched();
  }

  extractHexCodes(useTextAreaValue = true) {
    if (useTextAreaValue) {
      this.textareaValue = this.colorTextarea.nativeElement.value;
    }
    this.wrongColors = [];
    const colorRegex = /^\#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;
    const lines = this.textareaValue.split('\n');

    const colors = lines
      .map((line) => line.trim())
      .filter((line) => line !== '');
    const validatedColors = colors.map((color: string, index: number) => {
      if (colorRegex.test(color)) {
        return color;
      }
      if (!this.wrongColors.includes(index)) {
        this.wrongColors.push(index);
      }
      return color;
    });
    this.colors = validatedColors;
  }

  // ControlValueAccessor methods

  writeValue(value: any): void {
    if (value) {
      this.colors = value;
      this.textareaValue = this.colors.join('\n');
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.colorTextarea?.nativeElement.setAttribute('disabled', 'true');
    } else {
      this.colorTextarea?.nativeElement.removeAttribute('disabled');
    }
  }
}
